// src/utils/date.ts

export const formatDate = (timestamp: number): string => {
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  
  export const formatTimeAgo = (timestamp: number): string => {
    const now = Date.now();
    const diffInSeconds = Math.floor((now - timestamp) / 1000);
  
    if (diffInSeconds < 60) {
      return 'just now';
    }
  
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    }
  
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours}h ago`;
    }
  
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return `${diffInDays}d ago`;
    }
  
    return formatDate(timestamp);
  };
  
  // Add this to src/utils/date.ts
  export const formatDatePreserveDay = (dateString: string): string => {
    // Extract just the date portion from ISO string
    const [year, month, day] = dateString.split('T')[0].split('-');
    // Create a new date using year, month (0-indexed), day
    return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString();
  };
  
  /**
   * Formats an ISO date-time string (YYYY-MM-DDTHH:MM) into a user-friendly format
   * @param isoDateString ISO date string in format YYYY-MM-DDTHH:MM
   * @returns Formatted date/time string like "January 1, 2023 at 2:30 PM"
   */
  export const formatAppointmentDateTime = (isoDateString: string): string => {
    if (!isoDateString) return '';
    
    try {
      // Parse the date carefully to avoid timezone issues
      const [datePart, timePart] = isoDateString.split('T');
      
      if (!datePart || !timePart) return isoDateString;
      
      const [year, month, day] = datePart.split('-').map(num => parseInt(num, 10));
      const [hours, minutes] = timePart.split(':').map(num => parseInt(num, 10));
      
      // Create date object (use UTC to avoid timezone shifts)
      const date = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      
      // Format the date part
      const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      
      // Format the time part
      let hour = hours % 12;
      if (hour === 0) hour = 12; // Convert 0 to 12 for 12 AM/PM format
      const period = hours >= 12 ? 'PM' : 'AM';
      const formattedTime = `${hour}:${minutes.toString().padStart(2, '0')} ${period}`;
      
      return `${dateFormatter.format(date)} at ${formattedTime}`;
    } catch (error) {
      console.error('Error formatting appointment date/time:', error);
      return isoDateString; // Return original string if parsing fails
    }
  };